<template>
    <div class="lecture-info">
        <common-header left-div="back" title="시리즈 소개" />

        <!-- 동화 정보 -->
        <div class="lecture-info-section">
            <div class="lecture-tag" hidden>
                <div class="subject" v-if="lectureInfo.lecture_div === '20'">{{ lectureInfo.plan_subject_name }}</div>
                <div class="subject" v-else>{{ lectureInfo.subject_name }}</div>
                <div class="school-grade school-hig" v-if="lectureInfo.school_div === '99'">{{ lectureInfo.school_div_name | convertSchoolGrade }}</div>
                <div class="school-grade school-mid" v-else-if="lectureInfo.school_div === '20'">{{ lectureInfo.school_div_name | convertSchoolGrade }}</div>
                <div class="school-grade" v-else>{{ lectureInfo.school_div_name | convertSchoolGrade }}</div>
            </div>
            <div class="lecture-title">{{ lectureInfo.lecture_title }}</div>
            <div class="lecture-teacher" hidden>
                <div class="name">{{ lectureInfo.teacher_name }}</div>
                <div class="section">{{ lectureInfo.teacher_div_name }}</div>
            </div>
            <div class="lecture-photo">
                <img class="course-photo" v-if="lectureInfo.lecture_image_url !== null && lectureInfo.lecture_image_url !== ''" v-bind:src="lectureInfo.lecture_image_url" />
                <img class="course-photo" v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/content/course/201908/da2302a0d96147c5b40d43e5e94782cf.png" />
            </div>
            <!--
            <div class="lecture-like-view">
                <div class="like">
                    <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/like.png" width="22" height="17" />
                    <div class="count">{{ lectureInfo.like_count }}</div>
                </div>
                <div class="view">
                    <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/view.png" width="19" height="12" />
                    <div class="count">{{ lectureInfo.view_count }}</div>
                </div>
            </div>
            -->
            <div class="lecture_introduce" v-html="lectureInfo.lecture_introduce"></div>
        </div>

        <!-- 동화 List -->
        <div class="lecture-list-section">
            <div class="list-title">
                <div class="title">전체동화 <span v-html="courseList.length">0</span>강</div>
                <div class="button" v-if="courseList.length !== 0">
                    <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/play.png" width="17" height="18" @click="playAllCourse()" />
                    <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/push.png" width="18" height="17" @click="putAllCourse()" hidden/>
                </div>
            </div>
            <ul class="lecture-list">
                <li v-for="course in courseList">
                    <div class="lecture-title">
                        <div class="word_comma_1" @click="playLecture(course.course_no)">{{ course.course_name }}</div>
                        <div class="lecture-view">
                            <div class="time"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/clock-gray.png" width="11" height="11" />{{ course.course_time }}</div>
                            <div class="count">
                                <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/view-gray.png" width="12" height="8" />{{ course.view_count }}</div>
                        </div>
                    </div>
                    <div class="play-button" @click="playLecture(course.course_no)"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/play-color.png" width="15" height="16" /></div>
                    <div class="menu-button" @click="presentActionSheet(course.course_no)"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/preview/menu.png" width="3" height="12" /></div>
                </li>
            </ul>
        </div>

        <!-- 플레이리스트 선택 ion-select (화면에는 숨김)-->
        <ion-select v-show="false" mode="ios" interface="action-sheet" cancel-text="취소" @ionChange="putPlayList($event.target.value)">
            <ion-select-option v-bind:value="0"> 새 플레이리스트 추가</ion-select-option>
            <ion-select-option v-bind:value="list.playlist_no" v-for="(list, index) in myPlayList" :key="index">{{ list.title }}</ion-select-option>
        </ion-select>

        <footer-toolbar />
    </div>
</template>



<script>
    import * as biz from '../../utils/biz';
    import * as ajax from '../../utils/ajax';
    import * as alert from '../../utils/alert';
    import * as utils from "../../utils/utils";
    import CommonHeader from "../../components/header/CommonHeader";
    import FooterToolbar from "../../components/footer/FooterToolbar";

    export default {
        name: 'LectureInfo',
        components: {CommonHeader, FooterToolbar},
        props: {
            lecture_no: String
        },
        data() {
            return {
                isLogin: false,
                isActive: false,
                putCourseNo: "",
                lectureInfo: {},
                courseList: [],
                myPlayList: []
            }
        },
        beforeRouteLeave (to, from, next) {
            const url = to.path;
            if (url.indexOf("/preview/lecture") === -1) {
                this.$cookie.set("tempSchoolDiv", "");
                this.$cookie.set("tempSchoolGrade", "");
            }
            next(vm => {});
        },
        created() {
            this.isLogin = biz.isLogin(this);
            this.$store.state.toolbarActivePosition = "preview";
            this.$store.state.basicPlayerVisiblity = true;
        },
        mounted() {
            const url = "/api/contents/lecture/" + this.lecture_no;
            ajax.Get(this, url, function(ref, data) {
                ref.lectureInfo = data;
                ref.lectureInfo.school_div_name = data.school_div_name + data.school_grade_name.replace(/학년/gi, "");
            });
            this.getCourseList();
        },
        methods: {
            playAllCourse() {
                if (this.courseList.length !== 0) {
                    biz.playAudioPlayer(this.courseList[0].course_no);
                }
            },
            putAllCourse() {
                if (!this.isLogin) {
                    alert.alertLogin(this);
                    return;
                }
                if (this.courseList.length !== 0) {
                    for(let index in this.courseList) {
                        const params = {
                            interest_div: "20",
                            relation_no: this.courseList[index].course_no
                        };
                        ajax.Post(this, "/api/board/interest/list", params, function(ref, data) {});
                    }
                    alert.alert("동화를 담았습니다.", "확인");
                }
            },
            playLecture(course_no) {
                biz.playAudioPlayer(course_no);
            },
            getCourseList() {
                const params = {
                    lecture_no: this.lecture_no,
                    public_yn: "Y",
                    open_date: "today"
                };
                ajax.Post(this, "/api/contents/course/search", params, function(ref, data) {
                    ref.courseList = data;
                });
            },
            getMyPlayList() {
                const params = {};
                ajax.Post(this, "/api/member/playlist/search", params, function(ref, data) {
                    ref.myPlayList = data;
                });
            },
            presentActionSheet(course_no) {
                if (!this.isLogin) {
                    alert.alertLogin(this);
                    return;
                }
                this.getMyPlayList();
                return this.$ionic.actionSheetController
                    .create({
                        mode: "ios",
                        buttons: [
                            {
                                text: '동화담기',
                                handler: () => {
                                    this.putCourse(course_no);
                                },
                            },
                            /*{
                                text: '다운로드',
                                handler: () => {
                                    this.downloadCourse(course_no);
                                },
                            },*/
                            {
                                text: '플레이리스트',
                                handler: () => {
                                    this.playListCourse(course_no);
                                },
                            },
                            {
                                text: '취소',
                                role: 'cancel',
                                handler: () => {
                                },
                            }
                        ]
                    }).then(a => a.present())
            },
            putCourse(course_no) {
                const params = {
                    interest_div: "20",
                    relation_no: course_no
                };
                ajax.Post(this, "/api/board/interest/", params, function(ref, data) {
                    ref.isActive = data.my_count > 0;

                    if (ref.isActive) {
                        alert.alert("동화를 담았습니다.", "확인");
                    } else {
                        alert.alert("담은 동화를 삭제 하였습니다.", "확인");
                    }
                });
            },
            downloadCourse(course_no) {
                console.log("DOWNLOAD");
            },
            playListCourse(course_no) {
                this.putCourseNo = course_no;
                const select = document.querySelector('.lecture-info ion-select[interface="action-sheet"]');
                select.value = '';
                select.click();
            },
            putPlayList(playlist_no) {
                if (playlist_no === "0") {
                    this.addPlayList();
                } else if (playlist_no !== "" && playlist_no !== null) {
                    const params = {
                        course_no: this.putCourseNo,
                        playlist_no: playlist_no
                    };
                    ajax.Post(this, "/api/member/playlist/detail", params, function (ref, data) {
                        ref.isActive = data.my_count > 0;

                        if (ref.isActive) {
                            alert.alert("동화를 추가 하였습니다.", "확인");
                        } else {
                            alert.alert("추가한 동화를 삭제 하였습니다.", "확인");
                        }
                    });
                }
            },
            addPlayList() {
                alert.alertPrompt(this, "새 플레이 리스트 추가", "이름을 입력해 주세요.", function(ref, data) {
                    const params = {
                        title: data["0"]
                    };
                    ajax.Post(ref, "/api/member/playlist/", params, function(ref, data) {
                        alert.alert("새 플레이리스트가 등록 되었습니다.", "확인");
                        ref.getMyPlayList();
                        ref.playListCourse(ref.putCourseNo);
                    });
                });
            },
        },
        filters: {
            convertSchoolGrade(value) {
                return utils.convertSchoolGrade(value);
            }
        },
        computed: {
        }
    }
</script>

<style scoped lang="scss">
    div.lecture-info {
        overflow-y: auto;

        /** 동화 정보 **/
        div.lecture-info-section {
            padding: 17px 24px;
            border-bottom: 2px solid $line-secondary-color;

            div.lecture-tag {
                margin-top: 13px;
                display: flex;
                justify-content: center;

                font-size: $font-base12;

                div.subject {
                    margin-right: 3px;
                    height: 22px;
                    padding: 0 8px;
                    border: 1px solid $fifth-color;
                    border-radius: 22px;
                    line-height: 20px;
                    text-align: center;
                    color: $fifth-color;
                }
                div.school-grade {
                    height: 22px;
                    padding: 0 8px;
                    border: 1px solid $primary-color;
                    border-radius: 22px;
                    line-height: 20px;
                    text-align: center;
                    color: $primary-color;
                }
                div.school-grade.school-mid {
                    border: 1px solid $sixth-color;
                    color: $sixth-color;
                }
                div.school-grade.school-hig {
                    border: 1px solid $font-fifth-color;
                    color: $font-fifth-color;
                }
            }
            div.lecture-title {
                margin-top: 9px;
                font-weight: $font-weight500;
                text-align: center;
            }
            div.lecture-teacher {
                margin-top: 5px;
                display: flex;
                justify-content: center;
                font-size: $font-base14;

                div.name {
                    margin-right: 4px;
                    color: #222222;
                }
                div.section {
                    color: #27992a;
                }
            }
            div.lecture-photo {
                margin: 30px 16px 15px 16px;
                img.course-photo {
                    width: 100%;
                    border-radius: 2%;
                }
            }
            div.lecture-like-view {
                clear:right;

                margin: 0 1px;
                display: flex;
                justify-content: space-between;

                div.like {
                    display: flex;
                    align-items: center;

                    div.count {
                        margin-left: 10px;
                        font-size: $font-base12;
                    }
                }
                div.view {
                    display: flex;
                    align-items: center;

                    div.count {
                        margin-left: 10px;
                        font-size: $font-base12;
                    }
                }
            }
            div.lecture_introduce {
                margin: 40px auto;
                color: $font-third-color;
            }
        }

        /** 동화 List **/
        div.lecture-list-section {
            padding: 17px 24px;
            background-color: $line-third-color;

            div.list-title {
                display: flex;
                justify-content: space-between;
                margin-bottom: 16px;

                div.title {
                    font-weight: $font-weight500;
                    span {
                        color: $primary-color;
                    }
                }
                div.button {
                    img {
                        vertical-align: middle;
                        margin-left: 22px;
                     }
                }
            }
            ul.lecture-list {
                width: 100%;
                margin: 0;
                padding: 0 0 110px 0;
                list-style: none;

                li {
                    display: flex;
                    justify-content: flex-end;
                    padding: 16px 0;

                    div.lecture-title {
                        flex: 1;
                        max-width: calc(100% - 60px);

                        div.lecture-view {
                            display: flex;
                            justify-content: flex-start;

                            font-size: $font-base12;
                            color: $font-third-color;

                            div.time {
                                img {
                                    margin-right: 3px;
                                }
                            }
                            div.count {
                                margin-left: 10px;
                                img {
                                    margin-right: 3px;
                                }
                            }
                        }
                    }
                    div.play-button {
                        width: 36px;
                        text-align: center;
                    }
                    div.menu-button {
                        width: 24px;
                        text-align: right;
                    }
                }
            }
        }
    }

</style>
